import { gql } from "@apollo/client";

const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateMeInput!) {
    updateMe(input: $input) {
      me {
        givenName
        familyName
        locale
      }
      credentials {
        uid
        accessToken
        client
      }
    }
  }
`;

export default UPDATE_PROFILE;
